import React from 'react';
import { partial } from 'filesize';
import { FileInput, Button, Text } from '@leverege/ui-elements';
import S from './ImageInput.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default class ImageInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null
    };
  }
  filesize = partial({
    standard: 'jedec'
  });
  onImageSelect = async evt => {
    const {
      onChange
    } = this.props;
    this.setState(() => ({
      error: null
    }));
    const file = evt?.value[0];
    if (file.size > 5000000) {
      this.setState(() => ({
        error: 'Image size must be less than 5 MB'
      }));
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      if (typeof onChange === 'function') {
        onChange({
          data: 'image',
          value: {
            preview: reader.result,
            file
          },
          original: evt.original
        });
      }
    };
  };
  onImageDelete = evt => {
    const {
      onChange
    } = this.props;
    onChange({
      data: 'image',
      value: null,
      original: evt.original
    });
  };
  render() {
    const {
      image
    } = this.props;
    const {
      error
    } = this.state;
    let imgBlock;
    if (image) {
      imgBlock = /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsxs("div", {
          className: S.imagePreviewContainer,
          children: [/*#__PURE__*/_jsx("img", {
            src: image.preview,
            className: S.imagePreview,
            alt: "Beacon Installation"
          }), /*#__PURE__*/_jsxs("div", {
            className: S.imageInfo,
            children: [/*#__PURE__*/_jsx(Text, {
              variant: "detailValue",
              className: S.imageFilename,
              children: image.file.name
            }), /*#__PURE__*/_jsx(Text, {
              className: S.imageSize,
              children: this.filesize(image.file.size)
            })]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(FileInput, {
            variant: "upload",
            onChange: this.onImageSelect,
            fileTypes: 'image/*',
            eventData: "image",
            value: image,
            className: S.replaceImageButton,
            children: "Replace Image"
          }), /*#__PURE__*/_jsx(Button, {
            variant: "link",
            className: S.deleteImageLink,
            onClick: this.onImageDelete,
            children: "Delete"
          })]
        })]
      });
    } else {
      imgBlock = /*#__PURE__*/_jsx(FileInput, {
        variant: "upload",
        onChange: this.onImageSelect,
        fileTypes: 'image/*',
        eventData: "image",
        value: image
      });
    }
    return /*#__PURE__*/_jsxs(React.Fragment, {
      children: [error ? /*#__PURE__*/_jsx(Text, {
        variant: "errorCaption",
        children: error
      }) : '', imgBlock]
    });
  }
}